import { Backdrop, Button, CircularProgress, IconButton, Stack } from '@mui/material';
import dayjs from 'dayjs';
import React, { useState } from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import createDefaultTemplate from 'src/services/campian/createDefaultTemplateByNumber';
import { useAuthContext } from 'src/auth/useAuthContext';
import { notify } from 'src/components/notify';

export default function useColums(setEditData, handleOpenModal, handleAssignOpenModal, handleDeleteAssignOpenModal, setType, handleStatusAssignOpenModal, handleAccountOpenModal) {
    function formatStatus(status) {
        return typeof status == "string" ? status
            ?.split('_') // Split by underscore
            ?.map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
            ?.join(' ') : status
    }
    const { user } = useAuthContext()
    const [statusCheck, setStatusCheck] = useState(false)
    const colums = {
        0: [
            {
                id: "SI No",
                label: "SI No",
                renderCell: (_, index) => {
                    return index + 1;
                },
            },
            {
                id: "Group Name",
                label: "Group Name",
                renderCell: (row, index) => {
                    return row?.name
                },
            },
            {
                id: "Vendors",
                label: "Partners",
                renderCell: (row, index) => {
                    return <Stack sx={{
                        maxHeight: "100px", overflowX: "auto", padding: "10px 0", scrollbarWidth: "2px", // For Firefox
                        "&::-webkit-scrollbar": {
                            display: "none", // For Chrome, Safari, and Edge
                        },
                    }}>
                        {
                            row?.vendorsData ? row?.vendorsData?.map((it) => it.name)?.join(", ") : "All Vendors"
                        }
                    </Stack>
                },
            },
            {
                id: "CreatedAt",
                label: "CreatedAt",
                renderCell: (row, index) => {
                    return dayjs(row?.createdAt).format("DD/MM/YYYY hh:mm A")
                },
            },
            {
                id: "Action",
                label: "Action",
                renderCell: (row, index) => {
                    return <Stack direction="row" gap="5px" justifyContent="center">
                        <IconButton color="primary" onClick={() => { setEditData(row); handleOpenModal() }}>
                            <EditIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => { setEditData(row); handleDeleteAssignOpenModal(); setType('group') }}>
                            <DeleteIcon />
                        </IconButton>
                    </Stack>
                },
            },
        ],
        1: [
            {
                id: "SI No",
                label: "SI No",
                renderCell: (_, index) => {
                    return index + 1;
                },
            },
            {
                id: "Group Name",
                label: "Group Name",
                renderCell: (row, index) => {
                    return row?.group?.name
                },
            },
            {
                id: "display_name",
                label: "Display Name",
                // renderCell: (row, index) => {
                //     return row?.group?.name
                // },
            },
            {
                id: "Group Number",
                label: "Group Number",
                renderCell: (row, index) => {
                    return row?.display_number
                },
            },
            {
                id: "phone_number_id",
                label: "Phone Number Id",
                // renderCell: (row, index) => {
                //     return row?.display_number
                // },
            },
            {
                id: "msg_limit",
                label: "Message Limit",
            },
            {
                id: "Create Default Template",
                label: "Create Default Template",
                renderCell: (row) => {
                    return <>
                        {statusCheck && <Backdrop
                            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000000 }}
                            open={statusCheck}
                        >
                            <CircularProgress color="inherit" />
                        </Backdrop>}
                        <Button variant="contained" onClick={() => handleSubmit(row)}>
                            Create
                        </Button>
                    </>
                },
                width: 150
            },
            {
                id: "Status",
                label: "Status",
                renderCell: (row, index) => {
                    return row?.status == 'deleted' ? "Deleted" : "Live"
                },
            },
            {
                id: "CreatedAt",
                label: "CreatedAt",
                renderCell: (row, index) => {
                    return dayjs(row?.createdAt).format("DD/MM/YYYY hh:mm A")
                },
            },
            {
                id: "Action",
                label: "Action",
                renderCell: (row, index) => {
                    return (
                        <Stack direction="row" gap="10px" justifyContent="center">

                            <IconButton color="primary" onClick={() => { setEditData({ ...row, isEdit: true }); handleAssignOpenModal() }}>
                                <EditIcon />
                            </IconButton>
                            <IconButton color="error" onClick={() => { setEditData(row); handleDeleteAssignOpenModal(); setType('assign_group') }}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )
                },
            },
        ],
        2: [
            {
                id: "SI No",
                label: "SI No",
                renderCell: (_, index) => {
                    return index + 1;
                },
            },
            {
                id: "display_name2",
                label: "Display Name",
                renderCell: (row, index) => {
                    return row?.display_name
                },
            },
            {
                id: "phone_number",
                label: "Phone Number",
                // renderCell: (row, index) => {
                //     return row?.display_name
                // },
            },
            {
                id: "status1",
                label: "Status",
                renderCell: (row, index) => {
                    return row?.status ? formatStatus(row?.status || "") : row?.status
                },
            },
            {
                id: "Group Name",
                label: "CreatedAt",
                renderCell: (row, index) => {
                    return dayjs(row?.createdAt).format("DD/MM/YYYY hh:mm A")
                },
            },
            {
                id: "Action",
                label: "Action",
                renderCell: (row, index) => {
                    return <Stack direction="row" gap="5px" justifyContent="center">
                        {/* <IconButton color="primary" onClick={() => { setEditData({ ...row, isEdit: false }); handleAssignOpenModal() }}>
                            <EditIcon />
                        </IconButton> */}
                        <IconButton onClick={() => { setEditData(row); handleStatusAssignOpenModal(); }}>
                            <VisibilityIcon />
                        </IconButton>
                    </Stack>
                },
            },
        ],
        3: [
            {
                id: "SI No",
                label: "SI No",
                renderCell: (_, index) => {
                    return index + 1;
                },
            },
            {
                id: "Group name",
                label: "Group Name",
                renderCell: (row, index) => {
                    return row?.group_name || "-"
                },
            },
            {
                id: "name",
                label: "Account Name",
                renderCell: (row, index) => {
                    return row?.name
                },
            },

            {
                id: "id",
                label: "Account Id",
            },
            {
                id: "Account Status",
                label: "Account Status",
                renderCell: (row, index) => {
                    return row?.phone_number_data?.verification_status || "-"
                },
            },
            {
                id: "Action",
                label: "Action",
                renderCell: (row, index) => {
                    return <Stack direction="row" gap="5px" justifyContent="center">
                        <IconButton color="primary" onClick={() => { setEditData({ ...row, isEdit: false }); handleAccountOpenModal() }}>
                            <EditIcon />
                        </IconButton>
                    </Stack>
                },
            },
        ]
    }

    const handleSubmit = async (data) => {
        try {
            setStatusCheck(true)
            const response = await createDefaultTemplate(user, { meta_acc_id: data?.waba_id, meta_phone_number_id: data?.phone_number_id, grp_id: data?.group?._id })
            if (response) {
                notify("Created Successfully.")
            }

        } catch (err) {
            console.log(err);

        } finally {
            setStatusCheck(false)
        }

    }
    return { colums }
}
